<template>
  <div>
    <v-navigation-drawer v-model="drawer" app>
      <v-list>
        <v-list-tile class="py-0 d-flex justify-center" three-line>
          <router-link
            style="text-decoration: none; color:#0c3063;"
            to="/"
            class="d-flex align-center"
          >
            <img src="@/assets/max_logo.png" alt="Vizmo" height="42" />
            <span class="headline mt-1">&nbsp;Admin</span>
          </router-link>
        </v-list-tile>
      </v-list>
      <v-list class="pt-0">
        <v-divider light />
        <template v-for="item in drawerItems" class="pt-3">
          <v-list-group
            v-if="item.children"
            :key="item.key"
            :value="/^\/max-admin\/(settings | vms)\/.+/g.test($route.path)"
            no-action
          >
            <v-list-tile slot="activator">
              <v-list-tile-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile-title>
            </v-list-tile>
            <template v-for="subItem in item.children">
              <v-list-group
                v-if="subItem.children"
                :key="subItem.key"
                :value="/^\/max-admin\/settings\/vms.+/g.test($route.path)"
                sub-group
                no-action
              >
                <v-list-tile slot="activator">
                  <v-list-tile-action>
                    <v-icon>{{ subItem.icon }}</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-title>
                    <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile
                  v-for="superSubItem in subItem.children"
                  :key="superSubItem.to"
                  :to="superSubItem.to"
                >
                  <v-list-tile-action>
                    <v-icon :small="superSubItem.small">{{ superSubItem.icon }}</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-title>
                    <v-list-tile-title>{{ superSubItem.title }}</v-list-tile-title>
                  </v-list-tile-title>
                </v-list-tile>
              </v-list-group>
              <v-list-tile v-else :key="subItem.to" :to="subItem.to">
                <v-list-tile-action>
                  <v-icon>{{ subItem.icon }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-title>
                  <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
                </v-list-tile-title>
              </v-list-tile>
            </template>
          </v-list-group>
          <v-list-tile v-else :key="item.to" :to="item.to">
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-title>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-title>
          </v-list-tile>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar color="primary" height="64" app>
      <v-toolbar-side-icon dark @click.stop="drawer = !drawer" />
      <v-toolbar-title>
        <span class="headline white--text">{{ this.$store.state.toolbarTitle }}</span>
      </v-toolbar-title>
      <v-spacer />
      <v-menu offset-y transition="slide-y-transition">
        <avatar
          slot="activator"
          :src="$store.state.profile['photoUrl']"
          :text="$store.state.profile['name']"
          color="accent"
        />
        <v-card class="max-shadow">
          <v-card-title>
            <span class="profile-name subheading">{{ $store.state.profile.name }}</span>
          </v-card-title>
          <v-divider />
          <v-list>
            <v-list-tile to="/max-admin/profile">
              <v-list-tile-content>
                <v-list-tile-title>Profile</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile @click="logout">
              <v-list-tile-content>
                <v-list-tile-title>Log Out</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card>
      </v-menu>
    </v-toolbar>
    <v-content>
      <transition
        :enter-active-class="transitionEnterClass"
        :leave-active-class="transitionLeaveClass"
        mode="out-in"
        name="fade"
      >
        <!-- TODO: seems keep-alive on child router-view is not working if parent has :key set on it -->
        <router-view />
      </transition>
    </v-content>
  </div>
</template>

<script>
import { auth, database } from '@/firebase';
import VListTile from 'vuetify/es5/components/VList/VListTile';
import VListGroup from 'vuetify/es5/components/VList/VListGroup';
import avatar from '@/components/common/Avatar';
import pageTransitionMixin from '@/mixins/page-transition-mixin';
import _toArray from '@/mixins/util-mixin';

export default {
  name: 'MaxAdmin',
  components: {
    avatar,
    VListTile,
    VListGroup
  },
  mixins: [pageTransitionMixin, _toArray],
  data() {
    return {
      drawer: false,
      firebaseListener: {},
      drawerItems: [
        {
          to: '/max-admin/dashboard',
          icon: 'dashboard',
          title: 'Dashboard',
          children: false
        },
        {
          to: '/max-admin/tenants',
          icon: 'domain',
          title: 'Tenants',
          children: false
        },
        {
          to: '/max-admin/visitor-management',
          icon: 'mdi-account-card-details',
          title: 'Visitor Management',
          children: [
            {
              to: '/max-admin/vms/visitor-log',
              icon: 'mdi-account-tie',
              title: 'Visitor Log'
            },
            {
              to: '/max-admin/vms/invites',
              icon: 'insert_invitation',
              title: 'Invites'
            },
            {
              to: '/max-admin/vms/visitors',
              icon: 'mdi-account-group',
              title: 'Visitors'
            },
            {
              to: '/max-admin/vms/devices',
              icon: 'tablet',
              title: 'Devices'
            }
          ]
        },
        {
          to: '/max-admin/facilities',
          icon: 'event_note',
          title: 'Meeting Rooms',
          children: false
        },
        {
          to: '/max-admin/amenities',
          icon: 'mdi-dumbbell',
          title: 'Amenities',
          children: false
        },
        {
          to: '/max-admin/fnb',
          icon: 'fastfood',
          title: 'Food & Beverage',
          children: false
        },
        {
          to: '/max-admin/help-desk',
          icon: 'headset_mic',
          title: 'Help Desk',
          children: false
        },
        {
          to: '/max-admin/analytics',
          icon: 'bar_chart',
          title: 'Analytics',
          children: [
            {
              to: '/max-admin/analytics/helpDesk',
              icon: 'headset_mic',
              title: 'Help Desk'
            },
            {
              to: '/max-admin/analytics/facilities',
              icon: 'mdi-dumbbell',
              title: 'Meeting Rooms'
            },
            {
              to: '/max-admin/analytics/users',
              icon: 'people',
              title: 'Active Users'
            }
          ]
        },
        {
          to: '/max-admin/settings',
          icon: 'settings',
          title: 'Settings',
          children: [
            {
              to: '/max-admin/settings/max-towers',
              icon: 'settings',
              title: 'Max Towers'
            },
            {
              to: '/max-admin/settings/visitorms',
              icon: 'mdi-account-card-details',
              title: 'Visitor Management',
              children: [
                {
                  to: '/max-admin/settings/vms/account',
                  icon: 'format_color_text',
                  title: 'Account',
                  small: true
                },
                {
                  to: '/max-admin/settings/vms/invites-settings',
                  icon: 'insert_invitation',
                  title: 'Invites',
                  small: true
                },
                {
                  to: '/max-admin/settings/vms/checkinflow',
                  icon: 'settings_input_component',
                  title: 'Checkin Flow',
                  small: true
                },
                {
                  to: '/max-admin/settings/vms/app-settings',
                  icon: 'settings_applications',
                  title: 'App Settings',
                  small: true
                },
                {
                  to: '/max-admin/settings/vms/notifications',
                  icon: 'notifications_active',
                  title: 'Notifications',
                  small: true
                }
              ]
            },
            {
              to: '/max-admin/settings/help-desk',
              icon: 'headset_mic',
              title: 'Help Desk'
            }
          ]
        }
      ]
    };
  },
  computed: {
    locRef() {
      return database.ref('/vms/locations');
    }
  },
  created() {
    this.drawer = this.$vuetify.breakpoint.lgAndUp;
    this.fetchLocation();
  },
  beforeDestroy() {
    this.locRef.off('value', this.firebaseListener.locationQuery);
  },
  methods: {
    capitalFirstLetter(text) {
      return text.substr(0, 1).toUpperCase();
    },

    fetchLocation() {
      const locationQuery = this.locRef.on(
        'value',
        locationSnapshot => {
          const locations = locationSnapshot.val();
          const locationArray = this._toArray(locations);
          const VMS = {
            lid: locationArray[0].id
          };
          this.$store.commit('setVMS', { VMS });

          // Update count widgets
          this.$store.dispatch('getVisitorLog');
          this.$store.dispatch('getActiveUsers');
          this.$store.dispatch('getTotalUsers');
        },
        error => {
          console.log(error);
        }
      );
      this.firebaseListener.locationQuery = locationQuery;
    },

    logout() {
      auth.signOut();
      // we need to set profile null so that login-guard doesn't add redirect query param
      this.$store.commit('setProfile', { profile: null });
      this.$router.push('/login');
    }
  }
};
</script>

<style scoped>
.vlist-active-tile {
  color: #04325d !important;
  background-color: rgb(4, 50, 93, 0.2) !important;
}

.avatar {
  cursor: pointer;
}

.profile-name {
  font-weight: 500;
}
</style>
